<template>
  <div class="footer-wrapper">
    <div class="footer-content">
      <div class="msg-content">
        <div class="msg-content-left">
          <img class="logo-name" src="@/assets/logo-name.png" alt="">
          <div class="logo-intro">{{ $t('footer.introduce') }}</div>
          <div>
            <img class="x-logo" src="@/assets/images/x-logo.png" alt="" @click="linkTo('https://x.com/thundersendme')">
            <img class="t-logo" src="@/assets/images/t-logo.png" alt="" @click="linkTo('https://t.me/thundersendSupport_Cn')">
          </div>
        </div>
        <div class="msg-content-right">
          <div class="msg-item">
            <div class="msg-item-label">{{ $t('footer.aboutUs') }}</div>
            <div class="msg-item-info" @click="routeToHome('')">{{ $t('footer.home') }}</div>
            <div class="msg-item-info" @click="routeToHome('features')">{{ $t('footer.function') }}</div>
            <div class="msg-item-info" @click="routeTo('hot')">{{ $t('footer.subscribe') }}</div>
            <div class="msg-item-info" @click="routeToHome('faq')">{{ $t('footer.qa') }}</div>
          </div>
          <div class="msg-item">
            <div class="msg-item-label">{{ $t('footer.toUse') }}</div>
            <div class="msg-item-info" @click="linkTo('https://www.youtube.com/watch?v=qbsE1oc6yvQ&feature=youtu.be')">{{ $t('footer.course') }}</div>
          </div>
          <div class="msg-item">
            <div class="msg-item-label">{{ $t('footer.contact') }}</div>
            <div class="msg-item-info" @click="linkTo('https://x.com/thundersendme')">X/twitter</div>
            <div class="msg-item-info" @click="linkTo('https://t.me/thundersendSupport_CN/')">Telegram Group</div>
          </div>
          <div class="msg-item">
            <div class="msg-item-label">{{ $t('footer.link') }}</div>
            <div class="msg-item-info" @click="linkTo('https://telegram.org/')">
              <img class="telegram-logo" src="@/assets/images/telegram.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="privacy-content">
        <span class="privacy-content-item">{{ $t('footer.privacy') }}</span>
        <span class="privacy-content-item">{{ $t('footer.protocal') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  name: 'Footer',
  data() {
    return {

    }
  },
  methods: {
    linkTo(url) {
      window.open(url, '_blank');
    },
    routeToHome(str) {
      if (str) {
        this.$router.push(`/home?id=${str}`);
      } else {
        this.$router.push('/home');
      }
    },
    routeTo(path) {
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
.footer-wrapper {
  background: #0F0E13;
  padding: 0 20px;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.msg-content {
  border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  padding: 48px 0 54px;
  display: flex;
}
.msg-content-left {
  display: flex;
  flex-direction: column;
  margin-right: 120px;
}
.logo-name {
  margin-bottom: 20px;
  height: 42px;
  width: 210px;
}
.logo-intro {
  margin-bottom: 40px;
  color: #fff;
}
.t-logo {
  width: 24px;
  height: 22.5px;
  cursor: pointer;
}
.x-logo {
  width: 24px;
  height: 19.5px;
  margin-right: 26px;
  cursor: pointer;
}
.msg-content-right {
  padding-top: 12px;
  display: flex;
}
.msg-item {
  margin-right: 105px;
  min-width: 76px;
}
.msg-item-label {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  margin-bottom: 19px;
  color: #fff;
}
.msg-item-info {
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
}
.telegram-logo {
  width: 48px;
  height: 48px;
  cursor: pointer;
}
.privacy-content {
  height: 80px;
  line-height: 80px;
}
.privacy-content-item {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-right: 60px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .footer-content {
    padding: 0 16px;
  }
  
  .msg-content {
    flex-direction: column;
    padding: 32px 0;
  }
  
  .msg-content-left {
    margin-right: 0;
    margin-bottom: 32px;
    align-items: center;
    text-align: center;
  }
  
  .logo-name {
    height: 36px;
    width: 180px;
  }
  
  .logo-intro {
    margin-bottom: 24px;
  }
  
  .msg-content-right {
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 0;
  }
  
  .msg-item {
    margin-right: 0;
    width: 48%; /* 调整宽度,留出间距 */
    margin-bottom: 24px;
  }
  
  .msg-item-label {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .msg-item-info {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .privacy-content {
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  
  .privacy-content-item {
    font-size: 14px;
    margin-right: 24px;
  }
}

@media screen and (max-width: 480px) {
  .msg-item {
    margin-right: 0;
    width: 48%; /* 调整宽度,留出间距 */
    margin-bottom: 24px;
    text-align: center;
  }
  
  .privacy-content-item {
    display: block;
    height: 40px;
    line-height: 40px;
    margin-right: 0;
  }
  
  .privacy-content {
    height: auto;
    padding: 10px 0;
  }
}
</style>